var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityLibrary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Toolbox/University-Library/Active/48px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Toolbox/University-Library/Active/48px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "University-Library",
    transform: "translate(7.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.07025948,28.2285714 L4.03551663,4.34285714",
    id: "Stroke-2",
    stroke: "#001823",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.331181653,37.9964063 L0.252888056,4.85512432 L3.71601414,0.0628992642 L31.1442641,9.17161552e-06 C32.4643305,-0.00358454796 33.5367707,1.04937529 33.5404123,2.3538955 L33.6077812,30.1998317 C33.609602,31.502555 32.5426241,32.5627023 31.2225577,32.566296 L4.46071371,32.6273892 L0.323898528,38 L30.253902,37.9299225 C30.253902,37.9299225 33.0943209,38.0790618 33.9100309,36.1061098",
    id: "Stroke-3",
    stroke: "#001823",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-5",
    stroke: "#DB3725",
    points: "24.9460414 10.8571429 24.9714286 21.8310751 22.9640276 23.8655887 15.0722398 23.8857143 13.0539586 21.8603487 13.0285714 10.8864164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2414595,10.8647429 L15.6700309,10.8495429",
    id: "Stroke-7",
    stroke: "#DB3725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0757452,10.8658286 L27.5043166,10.8484571",
    id: "Stroke-9",
    stroke: "#DB3725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5436307,34.5572 L4.5957452,36.0924 C4.5957452,36.0924 27.5409288,36.0272571 28.7377004,36.0229143 C30.4393049,36.0185714 30.6528881,34.4790286 30.6528881,34.4790286 L5.5436307,34.5572 Z",
    id: "Fill-11",
    fill: "#001823"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityLibrary);
export default __webpack_public_path__ + "static/media/UniversityLibrary.aa417b0cf51f075d4f60b963ec315754.svg";
export { ForwardRef as ReactComponent };